module.exports = __webpack_public_path__ + "static/media/arrow-left.025c5394.svg";